export const UPDATE_APPLICATION_DRAFT = 'UPDATE_APPLICATION_DRAFT';
export const GET_APPLICATION_REQUEST = 'GET_APPLICATION_REQUEST';
export const GET_APPLICATION_SUCCESS = 'GET_APPLICATION_SUCCESS';
export const GET_APPLICATION_FAILURE = 'GET_APPLICATION_FAILURE';
export const GET_INTEGRATIONS_REQUEST = 'GET_INTEGRATIONS_REQUEST';
export const GET_INTEGRATIONS_SUCCESS = 'GET_INTEGRATIONS_SUCCESS';
export const GET_INTEGRATIONS_FAILURE = 'GET_INTEGRATIONS_FAILURE';
